import { Component, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Subject, takeUntil } from 'rxjs';
import { AuthenticationService } from '@core/services';

@Component({
  templateUrl: './forgot-password.component.html',
  styleUrls: [
    '../../core/Styles/AccountShared/account-styles.css',
    './forgot-password.component.css'
  ]
})
export class ForgotComponent implements OnDestroy {

  public formSubmitAttempt: boolean = false;
  public submitSuccess: boolean = false;
  private unsubscribe$: Subject<void> = new Subject<void>();

  public form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(
    private authService: AuthenticationService
  ) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get email() { return this.form.get('email'); }

  public submit(): void {
    this.formSubmitAttempt = true;
    if (this.form.valid) {
      this.authService.forgotPassword(this.form.value)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: () => {
            this.submitSuccess = true;
          }
        })
    }
  }

}
